/**
 * Squelettes de chargement : ils epousent la forme du contenu attendu pour que
 * la page ne saute pas a l'arrivee des donnees.
 */
export function Squelette({ className = 'h-4 w-full' }: { className?: string }) {
  return <div aria-hidden="true" className={`animate-pulse rounded-md bg-surface-appuyee ${className}`} />;
}

export function BlocChargement({
  lignes = 3,
  libelle = 'Chargement…',
}: {
  lignes?: number;
  libelle?: string;
}) {
  return (
    <div className="space-y-2.5" role="status" aria-live="polite">
      <span className="sr-only">{libelle}</span>
      {Array.from({ length: lignes }, (_, index) => (
        <Squelette key={index} className={`h-3.5 ${index % 3 === 2 ? 'w-2/3' : 'w-full'}`} />
      ))}
    </div>
  );
}

/** Squelette calque sur la grille du tableau, pour eviter le saut de mise en page. */
export function SqueletteTableau({
  lignes = 8,
  colonnes = 5,
  libelle = 'Chargement du tableau…',
}: {
  lignes?: number;
  colonnes?: number;
  libelle?: string;
}) {
  return (
    <div className="p-4" role="status" aria-live="polite">
      <span className="sr-only">{libelle}</span>
      <div className="space-y-2">
        {Array.from({ length: lignes }, (_, ligne) => (
          <div key={ligne} className="flex gap-3">
            {Array.from({ length: colonnes }, (_, colonne) => (
              <Squelette
                key={colonne}
                className={`h-4 ${colonne === 0 ? 'w-1/4' : 'flex-1'} ${
                  (ligne + colonne) % 4 === 0 ? 'opacity-70' : ''
                }`}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

/** Squelette de tuile d'indicateur (tableau de bord). */
export function SqueletteTuile() {
  return (
    <div className="panneau space-y-3 p-4">
      <Squelette className="h-3.5 w-24" />
      <Squelette className="h-8 w-20" />
      <Squelette className="h-3 w-32" />
    </div>
  );
}
